import { h } from 'preact';
import { TwoPeopleIcon, FireIcon, HotelTagIcon } from '../icons';

interface UspTagProps {
  tagName: string;
  templateName: string;
}

/**
 * UspTag - Displays USP (Unique Selling Proposition) tags with icons
 *
 * **Features:**
 * - Shows USP tag with appropriate SVG icon based on templateName
 * - Maps template names to specific icons (2P, FIRE, HOTEL)
 * - Handles different USP tag types with proper styling
 */
const UspTag = ({ tagName, templateName }: UspTagProps) => {
  const renderIcon = () => {
    switch (templateName) {
      case "2P":
        return <TwoPeopleIcon className="text-white" />;
      case "FIRE":
        return <FireIcon className="text-white" />;
      case "HOTEL":
        return <HotelTagIcon className="text-[#FE4F28]" />;
      default:
        return null;
    }
  };

  return (
    <div className={`tag-container_${templateName}`}>
      <div className="tag-frame">
        {renderIcon()}
        <div className="tag-title">{tagName}</div>
      </div>
    </div>
  );
};

export default UspTag; 